import React from 'react';
import styled from 'styled-components';
import { withNamespaces, Trans } from 'react-i18next';

import { ModalTitle, Divider } from 'legacyComponents/styled/lib';
import { TextPage } from 'legacyComponents/pages/textPage';
import { Modal } from 'apps/modals/views/modal';
import guidelinesTextUrl from 'apps/modals/communityGuidelines/CommunityGuidelines.md';
import fetchTextDocument from 'utils/fetchTextDocument';

@withNamespaces()
export class CommunityGuidelinesModal extends Modal {
  constructor(props) {
    super(props);
    this.state = {
      content: '',
    };
    fetchTextDocument(guidelinesTextUrl).then(content =>
      this.setState({ content }),
    );
  }

  render() {
    return (
      <>
        <ModalTitle>
          <Trans>Wikifactory Community Guidelines</Trans>
        </ModalTitle>
        <Divider />
        <ModalContent>
          <TextPage>
            <div dangerouslySetInnerHTML={{ __html: this.state.content }} />
          </TextPage>
        </ModalContent>
      </>
    );
  }
}

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding-top: ${props => props.theme.spacing.medium};
`;
